module.exports = __webpack_public_path__ + "img/img9.4afc0553.jpeg";